import React, { Component } from 'react'
import Activity from "framework/containers/Activity"

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class CustomTemplateActivity extends Component {

	constructor(props){
		super(props)
		this.RenderedComponent = import("app/components/Base/CustomTemplate/CustomTemplateBrowser")
	}

	render() {
		return (
			<Activity 
				name="CustomTemplate"
				RenderedComponent={this.RenderedComponent}
                context="CustomTemplate"
                // formActions={DefaultUserGroupAction}
			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(CustomTemplateActivity)
